<template>
  <ValidationProvider :name="label" :rules="rules" v-slot="{ errors }">
    <b-field
      :label="label"
      :type="{ 'is-danger': errors.length > 0 }"
      :message="errors[0]"
    >
      <b-select
        v-bind="$attrs"
        v-on="$listeners"
        v-model="item"
        @input="$emit('input', item)"
      >
        <slot />
      </b-select>
    </b-field>
  </ValidationProvider>
</template>

<script>
export default {
  name: "BaseSelect",
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number]
    },
    rules: {
      type: String,
      default: "required"
    },
    label: {
      type: String,
      default: ""
    }
  },
  watch: {
    value() {
      this.item = this.value;
    }
  },
  data() {
    return {
      item: this.value
    };
  }
};
</script>